module.exports = __webpack_public_path__ + "img/main.c590fb1f.png";